<template>
  <q-dialog v-if="isMobile" 
  :model-value="visible" 
  @update:model-value="handleUpdate"
  @hide="handleHide"
  maximized 
  position="standard">
    <q-card class="about-dialog">
       <q-card-section class="row items-center q-pb-none q-pt-md q-px-md">
        <q-btn flat round icon="arrow_back" @click="goBack" class="q-mr-sm" />
         <!-- <q-space /> -->
        <div class="text-h6 text-weight-medium text-grey-8">{{$t('Settings')}}</div>
        <q-space />
      </q-card-section>
      
      <q-card-section>
        <SettingsContent @item-click="handleItemClick" />
      </q-card-section>
    </q-card>
  </q-dialog>

  <!-- Desktop: Dialog -->
  <q-dialog v-else 
  :model-value="visible" 
  @update:model-value="handleUpdate"
  @hide="handleHide"
  position="standard">
    <q-card class="about-dialog">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6 text-grey-8">{{$t('Settings')}}</div>
        <q-space />
        <q-btn flat round dense icon="close" @click="goBack" />
      </q-card-section>
      
      <q-card-section>
        <SettingsContent @item-click="handleItemClick" />
      </q-card-section>
    </q-card>
  </q-dialog>

   <!-- Account Dialog -->
  <Account
    @back="closeAccount"
    :visible="showAccount"
  />
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useQuasar } from 'quasar'
import SettingsContent from '@/specific/components/app/settings-content.vue'
import Account from './account.vue'

const $q = useQuasar()

const props = defineProps({
  visible: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['back', 'about-click', 'privacy-click', 'terms-click'])
const isMobile = computed(() => $q.screen.lt.md)

const goBack = () => {
  emit('back')
}

const handleUpdate = (value) => {
  console.log('Dialog update:model-value', value)
  if (!value) {
    emit('back')
  }
}

const handleHide = () => {
  console.log('Dialog hide event')
  emit('back')
}

const showAccount = ref(false)

const handleItemClick = (type) => {
  if (type === 'account') {
    showAccount.value = true
  } else if (type === 'language') {
    // Handle language
  }
}

const closeAccount = () => {
  showAccount.value = false
}
</script>

<style lang="scss" scoped>
.text-grey-8 {
  body.body--dark & {
    color: white !important;
  }
}
</style>